import styled from 'styled-components';

export const OTTalentSubmissionNote = styled.span`
  white-space: pre-line;
`;

export const OTCandidateName = styled.div`
  width: 100%;
`;

export const OTFlex = styled.div<{ fullHeight?: boolean }>`
  flex: 1;

  > * {
    height: ${({ fullHeight }) => (fullHeight ? `100%` : 'unset')};
  }
`;
